const PortfolioData = [
  {
    id: 1,
    category: 'Web app',
    tech: 'React | Redux | PostgreSQL | Node.js | Express.js | TailwindCSS',
    title: 'easternlightpharma.com',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/dev/src/assets/images/project-screenshoot/easternlight2.png',
    description: 'A web app built with PERN stack for Eastern light Pharmaceutical and bio medical wholesaler that helps them to post there products and make uses to see the details of the products.',
    seelive: 'https://easternlightpharma.com/',
    seesource: 'https://github.com/sentayhu19/Eastern-light-web',
  },
  {
    id: 2,
    category: 'Web site',
    tech: 'React',
    title: 'Cloud App',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/cloud.png',
    description: 'A Cloud Management website that has support and service pages built with TailwindCSS.',
    seelive: 'https://cloud-app-with-tailwind.vercel.app/',
    seesource: 'https://github.com/sentayhu19/Cloud-app-with-tailwind',
  },
  {
    id: 3,
    category: 'Web site',
    tech: 'JavaScript | HTML | CSS',
    title: ' ShowBox Movies.',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/movie.png',
    description: 'Search for info about your favorite movies and tv shows on the ShowBox Movie Database',
    seelive: 'https://deyemiobaa.github.io/Movie-Database/',
    seesource: 'https://github.com/sentayhu19/Movie-Database',
  },
  {
    id: 4,
    category: 'Node package',
    tech: 'TypeScript',
    title: 'Random String Generator Package',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/random-string-gen.png',
    description: 'This package will give random string based on the options provided',
    seelive: 'https://www.npmjs.com/package/randomized-string',
    seesource: 'https://github.com/Dagic-zewdu/random-string',
  },
  {
    id: 5,
    category: 'web site',
    tech: 'React',
    title: 'Covid-19 info Tracker',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/covid19.png',
    description: 'The Covid-19 data-app collects information from API and present data for the novel coronavirus.',
    seelive: 'https://covid-19-data-app1.netlify.app/',
    seesource: 'https://github.com/sentayhu19/COVID-19-data-app',
  },
  {
    id: 6,
    category: 'WEB app',
    tech: 'PHP | HTML | CSS | JavaScript',
    title: 'E-voting system for ethiopia',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/e-voting.png',
    description: 'E-voting system for Ethiopia is a web site that allows registration of voters, polling stations, constituency , political parties and individual candidates and allow voter to make vote and show progress for each parties.',
    seelive: 'https://github.com/sentayhu19/E-voting-system-for-Ethiopia',
    seesource: 'https://github.com/sentayhu19/E-voting-system-for-Ethiopia',
  },
  {
    id: 7,
    category: 'Web app',
    tech: 'React Firebase',
    title: 'Arada Chat',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/arada-chat.png',
    description: 'This is a chatting web app created using react-redux and firebase. Users can create a channel and talk on the channel and DM each other. [Site Under Construction]',
    seelive: 'https://arada-chat-git-features-powermotors.vercel.app/',
    seesource: 'https://github.com/sentayhu19/Arada-chat',
  },
  {
    id: 8,
    category: 'Web app',
    tech: 'React',
    title: 'Bookstore',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/bookstore.png',
    description: 'The Bookstore is a website to store books that allow users to: Display a list of books. Add a book. Remove a selected book.',
    seelive: 'https://serene-zabaione-53a1d6.netlify.app/',
    seesource: 'https://github.com/sentayhu19/Bookstore',
  },
  {
    id: 9,
    category: 'Web app',
    tech: 'JavaScript',
    title: 'Leaderboard',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/Portfolio/src/assets/images/project-screenshoot/leaderboard.png',
    description: 'JavaScript project for building the Leaderboard list app that accepts and shows the name and Score of players around the world . All data is preserved in external API which is the Leaderboard API.',
    seelive: 'https://sentayhu19.github.io/Leaderboard/dist/index.html',
    seesource: 'https://github.com/sentayhu19/Leaderboard',
  },
  {
    id: 10,
    category: 'Web site',
    tech: 'Vue.js | Tailwindcss',
    title: 'Apple UI-Clone',
    image: 'https://raw.githubusercontent.com/sentayhu19/Portfolio/dev/src/assets/images/project-screenshoot/apple-ui.png',
    description: 'This project is a clone of the user interface on Apple website, built using Vue.js and Tailwind CSS. The goal of the project is to recreate the look and feel of the original site as closely as possible.',
    seelive: 'https://apple-sentayhu.vercel.app/',
    seesource: 'https://github.com/sentayhu19/Apple-UI-Clone-Design',
  },

];
export default PortfolioData;
